import { getSortedResourceHubArticleCards } from '../resource-hubs/resource-hub-content';
import { getJobSearchGuidePublicSeo } from './job-search-guides-public-seo';

export type ResourceArticleLink = {
  title: string;
  description: string;
  path: string;
};

export type ResourceArticleLocale = 'en' | 'fi' | 'sv';

const RELATED_ARTICLES_UI: Record<
  ResourceArticleLocale,
  { title: string; readMoreText: string }
> = {
  en: { title: 'Related Articles', readMoreText: 'Read more →' },
  fi: { title: 'Aiheeseen liittyvät artikkelit', readMoreText: 'Lue lisää →' },
  sv: { title: 'Relaterade artiklar', readMoreText: 'Läs mer →' },
};

/** Hub article cards + job-search guides — canonical cross-link pool for resource spokes. */
export function buildRelatedResourceArticleLinks(locale: ResourceArticleLocale): ResourceArticleLink[] {
  const fromHub = getSortedResourceHubArticleCards().map((card) => ({
    title: card.copy[locale].title,
    description: card.copy[locale].description,
    path: card.href[locale],
  }));

  const pillar = getJobSearchGuidePublicSeo('finlandPillar', locale);
  const tracker = getJobSearchGuidePublicSeo('applicationTracker', locale);
  const guides: ResourceArticleLink[] = [
    {
      title: pillar.headline,
      description: pillar.description,
      path: pillar.path,
    },
    {
      title: tracker.headline,
      description: tracker.description,
      path: tracker.path,
    },
  ];

  const seen = new Set<string>();
  const merged: ResourceArticleLink[] = [];
  for (const link of [...fromHub, ...guides]) {
    if (seen.has(link.path)) {
      continue;
    }
    seen.add(link.path);
    merged.push(link);
  }
  return merged;
}

export function filterRelatedResourceArticlesForPage(
  articles: ResourceArticleLink[],
  currentPath: string,
): ResourceArticleLink[] {
  return articles.filter((article) => article.path !== currentPath);
}

export function getRelatedResourceArticlesForPage(
  locale: ResourceArticleLocale,
  currentPath: string,
): ResourceArticleLink[] {
  return filterRelatedResourceArticlesForPage(buildRelatedResourceArticleLinks(locale), currentPath);
}

export function getRelatedArticlesUiCopy(locale: ResourceArticleLocale): {
  title: string;
  readMoreText: string;
} {
  return RELATED_ARTICLES_UI[locale];
}
